import { signal } from '@preact/signals-core';

import { TransformedAuditBoard } from '../Types/Audit';

export const selectedAudit = signal<TransformedAuditBoard | undefined>(undefined);
